module.exports = __webpack_public_path__ + "static/media/myenrollmentsimg.f63eae84.png";